const StudyOption =
  [           //  📖 📝 📘 👑 📕 🎴 🧠 ☀️ 📅 🔁 🖼️ ❔

    {
      "_id": {
        "$oid": "68bfc8751e31918280ae47c0"
      },
      "name": "NCERT Book",
      "id": "ncertbook",
      "link": "/ncertbook",
      "symbol": "📖",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d759"
      },
      "name": "NCERT short note",
      "id": "ncertshortnote",
      "link": "/ncert-short-note",
      "symbol": "📝",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d75b"
      },
      "name": "Formulas",
      "id": "formula",
      "link": "/formulas",
      "symbol": "👑",
      "status": "true"
    },
        {
      "_id": {
        "$oid": "68bfc6dd1e31918280ae47a5"
      },
      "name": "Topters Notes",
      "id": "topernote",
      "link": "/topernote",
      "symbol": "📕",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68bfbb7a1e31918280ae46cf"
      },
      "name": "Flashcards",
      "id": "flashcard",
      "link": "/flashcards",
      "symbol": "🎴",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68bfbb991e31918280ae46d2"
      },
      "name": "Mindmaps",
      "id": "mindmap",
      "link": "/mindmaps",
      "symbol": "🧠",
      "status": "true"
    },
        {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d762"
      },
      "name": "NCERT Solution",
      "id": "ncertsolution",
      "link": "/ncert-solutions",
      "symbol": "📘",
      "status": "true"
    },
        {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d75a"
      },
      "name": "NEET Syllabus",
      "id": "syllabus",
      "link": "/syllabus",
      "symbol": "🗺️",
      "status": "true"
    },
  
    {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d75e"
      },
      "name": "Mock Test",
      "id": "mocktest",
      "link": "/quiz",
      "symbol": "📋",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d761"
      },
      "name": "Mock test for PYQ",
      "id": "previouseyearquiz",
      "link": "/previouse-year-quiz",
      "symbol": "📜",
      "status": "true"
    },
          {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d75c"
      },
      "name": "Important (DPP)",
      "id": "dpp",
      "link": "/practice-questions",
      "symbol": "☀️",
      "status": "true"
    },
        {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d75f"
      },
      "name": "NEET Important pyq",
      "id": "topimportantquestions",
      "link": "/top-important-questions",
      "symbol": "🔁",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d75d"
      },
      "name": "Year wise PYQ ",
      "id": "previousyearquestions",
      "link": "/previous-year-questions",
      "symbol": "📅",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68c2d94f896cd3756f1b0d13"
      },
      "name": "Chapter wise PYQ",
      "id": "chapterwisepyq",
      "link": "/chapter-wise-pyq",
      "symbol": "❔",
      "status": "true",
    },
    {
      "_id": {
        "$oid": "68bfbbef1e31918280ae46d5"
      },
      "name": "Diagram-Based Ques...",
      "id": "diagrambasedquestions",
      "link": "/diagram-based-questions",
      "symbol": "🖼️",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68c2d94f896cd3756f1b0d13"
      },
      "name": "Chapter wise PYQ",
      "id": "chapterwisepyq",
      "link": "/chapter-wise-pyq",
      "symbol": "❔",
      "status": "false"
    },

    {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d760"
      },
      "name": "Practice Random Que...",
      "id": "practicerandomquestion",
      "link": "/practice-random-question",
      "symbol": "🎲",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d763"
      },
      "name": "Bookmarked Questions",
      "id": "bookmarkedquestions",
      "link": "/bookmarked-questions",
      "symbol": "⭐",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d765"
      },
      "name": "Bookmarked PDFs",
      "id": "bookmarkedpdfs",
      "link": "/bookmarked-pdfs",
      "symbol": "📑",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d764"
      },
      "name": "Practice History",
      "id": "questionshistory",
      "link": "/questions-history",
      "symbol": "🕒",
      "status": "true"
    },
    {
      "_id": {
        "$oid": "68aea2a1ac23b33a6c17d766"
      },
      "name": "Study Progress",
      "id": "subjectprogress",
      "link": "/subject-progress",
      "symbol": "📊",
      "status": "true"
    },

    {
      "_id": {
        "$oid": "68c010769622342ce6122bbf"
      },
      "name": "Topic wise wightage",
      "id": "chapterwiseweightage",
      "link": "/chapter-wise-weightage",
      "symbol": "⚖️",
      "status": "true"
    }



  ]




export default StudyOption;